import {Component, EventEmitter, inject, OnInit, Output, signal, WritableSignal} from '@angular/core';
import {CmsApiService} from "../core/cms-api.service";

@Component({
    selector: 'app-faq-sidebar',
    templateUrl: './faq-sidebar.component.html',
    styleUrl: './faq-sidebar.component.scss',
    standalone: false
})
export class FaqSidebarComponent implements OnInit{
  // Injections
  private readonly cms: CmsApiService = inject(CmsApiService);

  @Output() closeFaqSidebar = new EventEmitter();

  faqData: WritableSignal<any> = signal([]);

  ngOnInit() {
    this.cms.getFaq().then((result) => {
      // @ts-ignore
      this.faqData.set(result.categories);
    })
  }
}
